import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "chart-grid chart-grid-4" }
const _hoisted_2 = { class: "chart-card" }
const _hoisted_3 = {
  key: 0,
  class: "no-data"
}
const _hoisted_4 = {
  key: 1,
  class: "chart-body"
}
const _hoisted_5 = { class: "chart-card" }
const _hoisted_6 = {
  key: 0,
  class: "no-data"
}
const _hoisted_7 = {
  key: 1,
  class: "chart-body"
}
const _hoisted_8 = { class: "chart-card" }
const _hoisted_9 = {
  key: 0,
  class: "no-data"
}
const _hoisted_10 = {
  key: 1,
  class: "chart-body"
}
const _hoisted_11 = { class: "chart-card" }
const _hoisted_12 = {
  key: 0,
  class: "no-data"
}
const _hoisted_13 = {
  key: 1,
  class: "chart-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "card-title" }, "Overall Status", -1)),
      (!_ctx.hasStatusData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "No Records Found"))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_apexchart, {
              type: "donut",
              height: "300",
              options: _ctx.statusChartOptions,
              series: _ctx.statusSeries
            }, null, 8, ["options", "series"])
          ]))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "card-title" }, "Status by Team", -1)),
      (!_ctx.hasTeamData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "No Records Found"))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_apexchart, {
              type: "bar",
              height: "300",
              options: _ctx.departmentChartOptions,
              series: _ctx.departmentSeries
            }, null, 8, ["options", "series"])
          ]))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "card-title" }, "Status by Location", -1)),
      (!_ctx.hasLocationData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, "No Records Found"))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_apexchart, {
              type: "bar",
              height: "300",
              options: _ctx.locationChartOptions,
              series: _ctx.locationSeries
            }, null, 8, ["options", "series"])
          ]))
    ]),
    _createElementVNode("div", _hoisted_11, [
      _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "card-title" }, "Overdue Aging", -1)),
      (!_ctx.hasAgingData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, "No overdue tasks"))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_apexchart, {
              type: "bar",
              height: "300",
              options: _ctx.agingChartOptions,
              series: _ctx.agingSeries
            }, null, 8, ["options", "series"])
          ]))
    ])
  ]))
}